export const DEFAULT_TRANSITION = 150;
